export const MainWaterproofingSystems = {
    "imageUrl": "/assets/imgs/services/12WaterproofingSystems/fondo.png",
    "eyebrow": "Waterproofing",
    "title": "Systems",
    "headingSpan": "PROTECTING YOUR BUILDING",
    "heading": "FROM WATER DAMAGE",
    "description": "Water intrusion can cause structural deterioration, mold growth, and costly repairs if left unchecked. At HRD Painting & Restoration, we specialize in comprehensive waterproofing solutions designed to seal, protect, and extend the lifespan of commercial and high-rise buildings.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};